jQuery(function ($) {
	$(".btn--jornada").on("click", function (e) {
		if ($(this).hasClass("active")) {
			$(this)
				.removeClass("active")
				.next(".persona__buttons")
				.removeClass("active");
			$(".persona").removeClass("active");
			$(".persona__links").removeClass("active");
		} else {
			$(".persona, .btn--jornada, .persona__links").removeClass("active");
			$(this)
				.addClass("active")
				.next(".persona__buttons")
				.toggleClass("active");

			let target = $(this).attr("data-target");
			$(this).parent().addClass("active");
			$(".link--" + target).addClass("active");
		}
	});
});
